import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck, Sparkles } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
const CHECKOUT_URL = 'https://oriammarketing.com/cart/45496051990726:1';
export function PricingSection() {
  const handleCheckout = () => {
    trackAddToCart(6.97, 'USD', 'USA Sin Caos PDF');
    window.open(CHECKOUT_URL, '_blank');
  };
  return <section id="pricing" className="py-24 px-4 bg-[#FDF8F3]" data-id="element-106">
      <div className="max-w-3xl mx-auto text-center" data-id="element-107">
        <FadeIn data-id="element-108">
          <div className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-xl border border-[#C75B3F]/10 relative overflow-hidden" data-id="element-109">
            {/* Decorative background circle */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-[#C75B3F]/5 rounded-full blur-3xl" data-id="element-110"></div>

            <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-6 relative z-10" data-id="element-111">
              Este no es un libro para inspirarte. <br data-id="element-112" />
              <span className="text-[#C75B3F]" data-id="element-113">
                Es un sistema para devolverte aire.
              </span>
            </h2>

            <div className="flex items-baseline justify-center gap-2 mb-4 relative z-10" data-id="element-114">
              <span className="text-6xl font-bold text-stone-900" data-id="element-115">$6.97</span>
              <span className="text-stone-500 font-medium" data-id="element-116">USD</span>
            </div>

            <p className="text-stone-500 mb-8 relative z-10" data-id="element-117">
              Menos que un café con una amiga — pero con resultados que duran
            </p>

            <div className="inline-block bg-stone-100 px-4 py-2 rounded-full text-stone-600 text-sm font-medium mb-8 relative z-10" data-id="element-118">
              PDF Descargable • Acceso Inmediato
            </div>

            <div className="flex justify-center mb-6 relative z-10" data-id="element-119">
              <Button fullWidth onClick={handleCheckout} className="max-w-md text-xl py-6 shadow-xl shadow-[#C75B3F]/20 group" data-id="element-120">
                <Sparkles className="inline-block mr-2 w-5 h-5" data-id="element-121" />
                Sí, quiero dejar de vivir al límite
              </Button>
            </div>

            <div className="flex items-center justify-center gap-2 text-sm text-stone-500 mb-8 relative z-10" data-id="element-122">
              <ShieldCheck className="w-4 h-4" data-id="element-123" />
              Pago seguro y encriptado
            </div>

            <p className="text-stone-600 italic border-t border-stone-100 pt-8 relative z-10" data-id="element-124">
              "Si hoy tu semana se siente como una emergencia permanente…
              empieza con un tablero. No para 'ser mejor'. Para dejar de vivir
              al límite."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}